import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Custom hook that automatically redirects unauthenticated users to login page
 * while preserving the current URL for redirect after login.
 */
export function useAuthGuard(): void {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated === false) {
      redirectToLogin();
    }
  }, [isAuthenticated, isLoading]);
}

/**
 * Utility function to redirect to login with current path preservation
 * Use this for imperative redirects outside of components
 */
export function redirectToLogin(currentPath?: string) {
  const path = currentPath || window.location.pathname + window.location.search;

  // Don't redirect with return path if already on login or root
  const redirectUrl =
    path !== '/login' && path !== '/'
      ? `/login?redirect_to=${encodeURIComponent(path)}`
      : '/login';

  window.location.href = redirectUrl;
}
